import './App.css';
import Cards from "./components/Cards";
import Fundo from "./components/Fundo";
import Links from "./components/Links";

const { default: Avatar } = require("./components/Avatar");

function App() {
  return (
    <>
    <Fundo/>
    <Avatar/>
    <Cards/>
    <Links/>
    </>
  );
}

export default App;
